@if (control) {
  @if (!control.valid && control.touched) {
    <div class="invalid-feedback" data-cy="requiredField" style="display: block">{{ errors }}</div>
  }
}
